import { routes as itemLocationRoutes } from "@/apps/dashboard/itemLocation/routing/routes";
import { itemRefurbStepRoutes } from "@/apps/dashboard/itemRefurbStep/routing/itemRefurbStepRoutes";
import { routes as refurbDiagnosisRoutes } from "@/apps/dashboard/refurbDiagnosis/routing/routes";
import { routes as transportRoutes } from "@/apps/dashboard/transport/routing/routes";
import { routes as paymentRoutes } from "@/apps/dashboard/payment/routing/routes";
import { warehouseDispatchRoutes } from "@/apps/dashboard/warehouseDispatch/routing/warehouseDispatchRoutes";
import verificationRoutes from "@/apps/dashboard/buyback/routing/verification/routes";

// Please keep the list organized by name to maintain readability

export const commonWithMailRoutes = {
  availableStores: {
    path: "/stores",
    name: "availableStores",
  },
  buybackConfirmationDocs: {
    path: "/buyback-confirmation-docs",
    name: "buybackConfirmationDocs",
  },
  buybackConfirmation: {
    path: "/buyback-confirmation",
    name: "buybackConfirmation",
  },
  cartCheckout: {
    path: "cart/:cartId/checkout",
    name: "cartCheckout",
  },
  organizationCgs: {
    path: "/cgs",
    name: "organizationCgs",
  },
  organizationCgu: {
    path: "/cgu",
    name: "organizationCgu",
  },
  organizationFaq: {
    path: "/faq",
    name: "organizationFaq",
  },
};

const errorRoutes = {
  accessDenied: {
    path: "/access-denied",
    name: "accessDeniedError",
  },
  notAvailable: {
    path: "/not-available",
    name: "notAvailable",
  },
  notFound: {
    path: "/404",
    name: "404",
  },
};

export const routes = {
  addDiagnosticQuestion: {
    path: "category/:categoryId/question/add",
    name: "addDiagnosticQuestion",
  },
  availableStores: {
    path: "/stores",
    name: "availableStores",
  },
  buybacks: {
    path: "/buybacks",
    name: "buybacks",
  },
  buybackCreate: {
    path: "/diag/:selectedProductId?/:selectedProductSlug?/:itemId?/:predeclaredBuybackId?",
    name: "buybackCreate",
  },
  buybackEdition: {
    path: "buyback/:id/edition/",
    name: "buybackEdition",
  },
  buybackQuestions: {
    path: "/micx-dashboard/buyback-questions/e70f3f38-24d9-448a-af50-44c55b2fc7e8",
    name: "buyback-questions",
  },
  search: {
    path: "/search",
    name: "search",
  },
  searchByCategories: {
    path: "/categories",
    name: "searchByCategories",
  },
  searchByCategory: {
    path: "/category/:id/:slug",
    name: "searchByCategory",
  },
  productSearchResults: {
    path: "/results",
    name: "productSearchResults",
  },
  buybacks_predeclared: {
    path: "/buybacks-predeclared",
    name: "buybacksPredeclared",
  },
  buybacksQuarantine: {
    path: "/buybacksQuarantine",
    name: "buybacksQuarantine",
  },
  estimateError: {
    path: "/estimate-error",
    name: "estimateError",
  },
  cartCustomerInformations: {
    path: "/cart/customer-infos",
    name: "cartCustomerInformations",
  },
  cartOrderSummary: {
    path: "/cart/summary",
    name: "cartOrderSummary",
  },
  categories: {
    path: "/categories/list",
    name: "categories",
  },
  catchAll: {
    path: "/:catchAll(.*)",
    name: "catchAll",
  },
  circuits: {
    path: "/circuits",
    name: "circuits",
  },
  clients: {
    path: "/clients",
    name: "clients",
  },
  complianceTest: {
    path: "/warehouse/check/:itemId?",
    name: "ComplianceTest",
  },
  configuration: {
    path: "/connectors/:configurationId",
    name: "configuration",
  },
  configurationInternalSftp: {
    path: "/configuration/:organizationId/sftp",
    name: "configurationInternalSftp",
  },
  configurationListConnectors: {
    path: "/connectors/:organizationId/configurations/:connectorId",
    name: "configurationListConnectors",
  },
  connectorListConnectors: {
    path: "/connectors/:organizationId/connectors",
    name: "connectorListConnectors",
  },
  createAdmin: {
    path: "userAdmin/create",
    name: "createAdmin",
  },
  createBuyback: {
    path: "/buyback/create",
    name: "createBuyback",
  },
  createCategory: {
    path: "/category/create",
    name: "createCategory",
  },
  createClient: {
    path: "/client/create",
    name: "createClient",
  },
  createConfiguration: {
    path: "/connectors/createConfiguration",
    name: "createConfiguration",
  },
  createEntity: {
    path: "/entity/create",
    name: "createEntity",
  },
  createProduct: {
    path: "/product/create",
    name: "createProducts",
  },
  createRefurbStep: {
    path: "/refurb-step/create",
    name: "createRefurbStep",
  },
  createUser: {
    path: "/user/create",
    name: "createUser",
  },
  createUserClient: {
    path: "userClient/create",
    name: "createUserClient",
  },
  design: {
    path: "/design",
    name: "design",
  },
  designSystem: {
    path: "/design-system",
    name: "design-system",
  },
  detailBuyback: {
    path: "/buyback/:id",
    name: "detailBuyback",
  },
  diagnostic: {
    path: "/diagnostic",
    name: "diagnostic",
  },
  diagnosticCategory: {
    path: "category/:categoryId",
    name: "diagnosticCategory",
  },
  editAdmin: {
    path: "userAdmin/:id/edit/",
    name: "editAdmin",
  },
  editBuyback: {
    path: "buyback/:id/edit/",
    name: "editBuyback",
  },
  editCategory: {
    path: "category/:id/edit/",
    name: "editCategory",
  },
  editCircuit: {
    path: "/circuit/:id/edit/",
    name: "editCircuit",
  },
  editClient: {
    path: "client/:organizationId/edit/",
    name: "editClient",
  },
  editClientPages: {
    path: "client/:id/editPages/",
    name: "editClientPages",
  },
  editDiagnosticQuestion: {
    path: "category/:categoryId/question/:questionId",
    name: "editDiagnosticQuestion",
  },
  editEntity: {
    path: "entity/:id/edit/",
    name: "editEntity",
  },
  editProduct: {
    path: "product/:id/edit/",
    name: "editProduct",
  },
  editRefurbStep: {
    path: "/refurb-step/:id/edit",
    name: "editRefurbStep",
  },
  editUser: {
    path: "user/:id/edit/",
    name: "editUser",
  },
  editUserClient: {
    path: "userClient/:id/edit/",
    name: "editUserClient",
  },
  entities: {
    path: "/entities",
    name: "entities",
  },
  exports: {
    path: "/exports/:organizationId",
    name: "exports",
  },
  home: {
    path: "/home",
    name: "home",
  },
  imports: {
    path: "/imports/:organizationId",
    name: "imports",
  },
  lcmRpsGeneralSettings: {
    path: "/settings/lcm/general",
    name: "lcmRpsGeneralSettings",
  },
  login: {
    path: "/login",
    name: "login",
  },
  lostPassword: {
    path: "/lostPassword",
    name: "lostPassword",
  },
  newDashboard: {
    path: "/micx-dashboard?password=new-xp",
    name: "micx-dashboard",
  },
  openIdLogin: {
    path: "/open-id/:organizationId/callback",
    alias: "/openid/:organizationId/callback",
    name: "openIdLogin",
  },
  openIdLogout: {
    path: "/open-id/logout",
    alias: "/openid/logout",
    name: "openIdLogout",
  },
  passwordConfirmation: {
    path: "/new/password",
    name: "passwordConfirmation",
  },
  passwordRenewal: {
    path: "/renew/:token",
    name: "passwordRenewal",
  },
  products: {
    path: "/products",
    name: "products",
  },
  refurbSteps: {
    path: "/refurb-steps",
    name: "refurbSteps",
  },
  sftpSettings: {
    path: "/settings/sftp",
    name: "sftpSettings",
  },
  ssoConfiguration: {
    path: "/connectors/:organizationId/SSO",
    name: "ssoConfiguration",
  },
  timGeneralSettings: {
    path: "/settings/tim/general",
    name: "timGeneralSettings",
  },
  transferOrderSettings: {
    path: "/settings/transfer-order",
    name: "transferOrderSettings",
  },
  users: {
    path: "/users",
    name: "users",
  },
  ...errorRoutes,
  ...commonWithMailRoutes,
  ...itemLocationRoutes,
  ...itemRefurbStepRoutes,
  ...paymentRoutes,
  ...refurbDiagnosisRoutes,
  ...transportRoutes,
  ...verificationRoutes,
  ...warehouseDispatchRoutes,
};
